import ResultDetail from '../../../modules/results/ResultDetail'

export default ResultDetail